__turbopack_context__.v({
  "menu_label": "MobileNavbar-module-scss-module__SLJpwG__menu_label",
  "navbar_brand": "MobileNavbar-module-scss-module__SLJpwG__navbar_brand",
  "navbar_container": "MobileNavbar-module-scss-module__SLJpwG__navbar_container",
  "sticky_ctas": "MobileNavbar-module-scss-module__SLJpwG__sticky_ctas",
  "title": "MobileNavbar-module-scss-module__SLJpwG__title",
  "trailing_items": "MobileNavbar-module-scss-module__SLJpwG__trailing_items",
  "trailing_items__close": "MobileNavbar-module-scss-module__SLJpwG__trailing_items__close",
  "trailing_items__hamburger": "MobileNavbar-module-scss-module__SLJpwG__trailing_items__hamburger",
  "trailing_items__user_avatar": "MobileNavbar-module-scss-module__SLJpwG__trailing_items__user_avatar",
  "treatment_navbar_container": "MobileNavbar-module-scss-module__SLJpwG__treatment_navbar_container",
  "treatment_navbar_expanded": "MobileNavbar-module-scss-module__SLJpwG__treatment_navbar_expanded",
  "treatment_trailing_items": "MobileNavbar-module-scss-module__SLJpwG__treatment_trailing_items",
  "treatment_wrapper_expanded": "MobileNavbar-module-scss-module__SLJpwG__treatment_wrapper_expanded",
  "visible": "MobileNavbar-module-scss-module__SLJpwG__visible",
});
